import * as React from 'react';
import { PaginationProps, Pagination } from './Pagination/Pagination';

export interface CompactControlBarProps {
    /**
     * Props for the Pagination component
     */
    pagination: PaginationProps;
}

export function CompactControlBar(props: CompactControlBarProps) {
    return (
        <div className="simple-data-table-info copia_color1_b" style={{height: 30, display: 'flex', justifyContent: 'center'}}>
            <Pagination {...props.pagination} />
        </div>
    );
}
